//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/TaggedObject.js";
let d=[[[0,"PropertyString",1,0],[0,"ResultString",0,0]],[[["newObject"],"ChangeEditObject",{},1,0],[["hierarchy"],"Populate",{},1,0],[["exp"],"SetExpression",{},1,0],[[],"DisconnectExpression",{},0,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.AME.ObjectConnectionDetailBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.ObjectConnectionDetailBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;